export default __webpack_public_path__ + "static/media/NewNumber.03c5a17b.png";